<template>
  <div class="home-container">
    <CarouselHome />
    <CompanyIntroduction />
    <!-- <TodoShow /> -->
    <!-- <div class="bottom_circle">
      <h1>{{ title }}</h1>
      <div class="circle_img">
        <img :src="img" alt="" class="hidden-xs-only" />
        <img :src="img" alt="" class="hidden-sm-and-up" />
      </div>
    </div> -->
    <BusinessIntroduction />
    <!-- <CoreCompetence /> -->
    <!-- <CooperationCustomer /> -->
    <!-- <NewsInfomation /> -->
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CarouselHome from '@/components/carousel_home/index'
import CompanyIntroduction from '@/components/company_introduction/index'
import TodoShow from '@/components/todo_show/index'
import BusinessIntroduction from '@/components/business_introduction/index'
import CoreCompetence from '@/components/core_competence/index'
import CooperationCustomer from '@/components/cooperation_customer/index'
import NewsInfomation from '@/components/news_infomation/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Constant from '../utils/Constant'
import { leftLikeDict } from '../api/system'
import { findMainProp } from '../utils'
export default {
  data() {
    return {
      img: '',
      title: ''
    }
  },
  components: {
    CarouselHome,
    CompanyIntroduction,
    TodoShow,
    BusinessIntroduction,
    CoreCompetence,
    CooperationCustomer,
    NewsInfomation,
    CallMe,
    MobileCallme
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.HOME3);
      if (res.data) {
        const { title, content } = findMainProp(res.data.data, Constant.HOME3)
        this.img = content
        this.title = title
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  }
}
</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
  overflow-x: hidden; /* 防止水平滚动条 */
  margin: 0;
  padding: 0;
  width: 100%;
  padding-top: 70px; /* 为固定导航栏预留空间 */
}

.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png), url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;

  h1 {
    font-size: 40px;
    padding-bottom: 20px;

    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }

  .circle_img {
    width: 100%;

    img {
      width: 70%;

      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
}
</style>
